import styled from 'styled-components';

import colors from '../../../../styles/colors';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  background: ${colors.$background_primary};
  border-radius: 8px;
  margin-bottom: 16px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 32px;
  padding-bottom: 0px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    column-gap: 16px;
    background: ${colors.$background_primary};
    border-radius: 8px;
    margin-bottom: 16px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 32px;
    padding-bottom: 0px;
  }
`;
